import { Link } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

import { routeCreator } from '../../../drive-insights.router';
import { DriveBackground } from '../../components/drive-background.component';

const rootSx: SxProps<Theme> = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const contentSx: SxProps<Theme> = {
  position: 'relative',
  textAlign: 'center',
  maxWidth: 480,
  px: 3,
};

export const EmptyConversationPlaceholder = () => (
  <Box sx={rootSx}>
    <DriveBackground />
    <Box sx={contentSx}>
      <Typography variant='h4' sx={{ color: 'drive.textPrimary', fontWeight: 600, mb: 1.5 }}>
        This conversation is not available
      </Typography>
      <Typography sx={{ color: 'drive.textSecondary', mb: 3 }}>
        There are no messages available for this conversation. Start a new one to keep going.
      </Typography>
      <Button variant='contained' component={Link} to={routeCreator.base()}>
        Start a New Conversation
      </Button>
    </Box>
  </Box>
);
